import { QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { del, get, set } from 'idb-keyval';
import { env } from './env';

const FIVE_MINUTES = 5 * 60 * 1000;
const THIRTY_MINUTES = 30 * 60 * 1000;
const ONE_HOUR = 60 * 60 * 1000;
export const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: FIVE_MINUTES,
      gcTime: ONE_HOUR,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const persister = createAsyncStoragePersister({
  storage: {
    getItem: (key) => get<string>(key).then((v) => v ?? null),
    setItem: (key, value) => set(key, value),
    removeItem: (key) => del(key),
  },
  key: `tickerbuzz-query-cache-${env.VITE_APP_VERSION}`,
});

export const queryTuning = {
  list: { staleTime: FIVE_MINUTES, gcTime: THIRTY_MINUTES },
  detail: { staleTime: FIVE_MINUTES, gcTime: ONE_HOUR },
  summary: { staleTime: THIRTY_MINUTES, gcTime: ONE_HOUR },
};
